import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
type ModalType = null | 'privacy' | 'terms';
export const Footer = () => {
  const [open, setOpen] = useState<ModalType>(null);
  const close = () => setOpen(null);
  return <footer className="relative w-full border-t border-amber-500/15 bg-cosmic-900/80 mt-12 pb-24 md:pb-16" data-id="element-33">
      <div className="max-w-4xl mx-auto px-6 py-10 flex flex-col items-center gap-6 text-center" data-id="element-34">
        {/* Ornament */}
        <div className="flex items-center gap-3 opacity-60" data-id="element-35">
          <div className="h-[1px] w-12 bg-gradient-to-r from-transparent to-gold-muted" data-id="element-36" />
          <div className="rotate-45 w-1.5 h-1.5 bg-gold-muted" data-id="element-37" />
          <div className="h-[1px] w-12 bg-gradient-to-l from-transparent to-gold-muted" data-id="element-38" />
        </div>

        <p className="font-serif italic text-amber-200/70 text-sm md:text-base max-w-md" data-id="element-39">
          La molécula ya estaba dentro de ti cuando empezaste.
        </p>

        <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm" data-id="element-40">
          <button onClick={() => setOpen('privacy')} className="text-gray-400 hover:text-amber-400 transition-colors font-sans tracking-wide" data-id="element-41">
            Política de Privacidad
          </button>
          <span className="text-gray-700" data-id="element-42">·</span>
          <button onClick={() => setOpen('terms')} className="text-gray-400 hover:text-amber-400 transition-colors font-sans tracking-wide" data-id="element-43">
            Términos y Condiciones
          </button>
        </nav>

        <p className="text-xs text-gray-600 font-sans tracking-wider mt-2" data-id="element-44">
          © {new Date().getFullYear()} DMT: La Molécula de Dios. Todos los
          derechos reservados.
        </p>
      </div>

      {/* Privacy Modal */}
      <Modal isOpen={open === 'privacy'} onClose={close} title="Política de Privacidad" data-id="element-45">
        <p className="text-sm text-gray-500 italic" data-id="element-46">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <h3 className="font-serif text-amber-400 text-lg mt-4" data-id="element-47">
          1. Introducción
        </h3>
        <p data-id="element-48">
          Esta Política de Privacidad describe cómo recopilamos, usamos y
          protegemos la información personal que proporcionas al adquirir el
          libro digital <em data-id="element-49">DMT: La Molécula de Dios</em>. Tu privacidad es
          fundamental para nosotros y nos comprometemos a tratarla con el mismo
          respeto con el que abordamos el contenido de este libro.
        </p>

        <h3 className="font-serif text-amber-400 text-lg mt-4" data-id="element-50">
          2. Información que recopilamos
        </h3>
        <p data-id="element-51">
          Cuando realizas una compra, recopilamos únicamente la información
          estrictamente necesaria para completar la transacción y entregarte el
          producto: nombre, dirección de correo electrónico y datos de pago
          procesados por nuestra pasarela de pagos certificada.
        </p>
        <p data-id="element-52">
          No almacenamos información de tarjetas de crédito en nuestros
          servidores. Los datos de pago son procesados directamente por
          proveedores que cumplen con el estándar PCI DSS.
        </p>

        <h3 className="font-serif text-amber-400 text-lg mt-4" data-id="element-53">
          3. Cómo usamos tu información
        </h3>
        <p data-id="element-54">
          Utilizamos tus datos exclusivamente para: procesar tu compra, enviarte
          el libro digital y comunicaciones esenciales relacionadas con tu
          pedido, atender solicitudes de garantía o reembolso, y cumplir con
          obligaciones legales aplicables.
        </p>
        <p data-id="element-55">
          Nunca vendemos, alquilamos ni compartimos tu información con terceros
          con fines comerciales.
        </p>

        <h3 className="font-serif text-amber-400 text-lg mt-4" data-id="element-56">
          4. Cookies y tecnologías similares
        </h3>
        <p data-id="element-57">
          Este sitio utiliza cookies funcionales y analíticas para mejorar tu
          experiencia de navegación, recordar tus preferencias y entender cómo
          se utiliza la página. Puedes gestionar las cookies desde la
          configuración de tu navegador en cualquier momento.
        </p>

        <h3 className="font-serif text-amber-400 text-lg mt-4" data-id="element-58">
          5. Tus derechos
        </h3>
        <p data-id="element-59">
          Tienes derecho a acceder, rectificar, eliminar y portar tus datos
          personales, así como a oponerte a su tratamiento o solicitar su
          limitación. Para ejercer cualquiera de estos derechos, puedes
          solicitarlo a través de los canales indicados en tu correo de
          confirmación de compra.
        </p>

        <h3 className="font-serif text-amber-400 text-lg mt-4" data-id="element-60">6. Seguridad</h3>
        <p data-id="element-61">
          Aplicamos medidas técnicas y organizativas razonables para proteger
          tus datos contra acceso no autorizado, pérdida o alteración. Sin
          embargo, ninguna transmisión por internet es completamente segura, y
          no podemos garantizar seguridad absoluta.
        </p>

        <h3 className="font-serif text-amber-400 text-lg mt-4" data-id="element-62">
          7. Conservación de datos
        </h3>
        <p data-id="element-63">
          Conservamos tus datos únicamente durante el tiempo necesario para
          cumplir con los fines descritos en esta política, o el plazo exigido
          por la legislación fiscal y comercial aplicable.
        </p>

        <h3 className="font-serif text-amber-400 text-lg mt-4" data-id="element-64">
          8. Cambios en esta política
        </h3>
        <p data-id="element-65">
          Podemos actualizar esta Política de Privacidad ocasionalmente. La
          versión vigente será siempre la publicada en esta página, con la fecha
          de última actualización indicada al inicio.
        </p>

        <p className="font-serif italic text-amber-200/80 mt-6 text-center" data-id="element-66">
          Lo que compartes contigo mismo al leer este libro queda entre tú y el
          silencio. Lo que compartes con nosotros queda protegido.
        </p>
      </Modal>

      {/* Terms Modal */}
      <Modal isOpen={open === 'terms'} onClose={close} title="Términos y Condiciones" data-id="element-67">
        <p className="text-sm text-gray-500 italic" data-id="element-68">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <h3 className="font-serif text-amber-400 text-lg mt-4" data-id="element-69">
          1. Aceptación de los términos
        </h3>
        <p data-id="element-70">
          Al acceder a este sitio web y/o adquirir el libro digital{' '}
          <em data-id="element-71">DMT: La Molécula de Dios</em>, aceptas quedar vinculado por estos
          Términos y Condiciones. Si no estás de acuerdo con alguno de los
          puntos aquí descritos, te pedimos que no realices la compra.
        </p>

        <h3 className="font-serif text-amber-400 text-lg mt-4" data-id="element-72">
          2. Naturaleza del producto
        </h3>
        <p data-id="element-73">
          El producto ofrecido es un libro digital (ebook) en formato
          descargable. Una vez completada la compra, recibirás acceso al archivo
          a través del correo electrónico proporcionado. El libro es una obra
          literaria y de divulgación científica de carácter informativo y
          reflexivo.
        </p>

        <h3 className="font-serif text-amber-400 text-lg mt-4" data-id="element-74">
          3. Aviso importante sobre el contenido
        </h3>
        <p data-id="element-75">
          El contenido de este libro tiene fines exclusivamente educativos,
          filosóficos y literarios. No constituye consejo médico, psicológico,
          terapéutico ni recomendación de uso de sustancia alguna. La DMT y
          otras sustancias mencionadas pueden estar reguladas o prohibidas en tu
          jurisdicción. El lector es plenamente responsable de respetar las
          leyes aplicables en su país de residencia.
        </p>

        <h3 className="font-serif text-amber-400 text-lg mt-4" data-id="element-76">
          4. Precio y pago
        </h3>
        <p data-id="element-77">
          Los precios mostrados están expresados en dólares estadounidenses
          (USD). Las ofertas y descuentos promocionales son válidos por el
          tiempo indicado en la página y pueden modificarse sin previo aviso. El
          pago se realiza a través de pasarelas seguras de terceros.
        </p>

        <h3 className="font-serif text-amber-400 text-lg mt-4" data-id="element-78">
          5. Garantía y reembolso
        </h3>
        <p data-id="element-79">
          Ofrecemos una garantía de satisfacción de 30 días naturales contados
          desde el momento de la compra. Si dentro de ese plazo consideras que
          el libro no cumplió con lo prometido, puedes solicitar el reembolso
          íntegro de tu compra a través de los canales habilitados, sin
          necesidad de justificación.
        </p>

        <h3 className="font-serif text-amber-400 text-lg mt-4" data-id="element-80">
          6. Licencia de uso
        </h3>
        <p data-id="element-81">
          Al adquirir el libro, obtienes una licencia personal, no exclusiva, no
          transferible y de uso individual. Queda expresamente prohibida la
          reproducción, distribución, reventa, modificación o difusión pública
          del contenido por cualquier medio sin autorización escrita.
        </p>

        <h3 className="font-serif text-amber-400 text-lg mt-4" data-id="element-82">
          7. Propiedad intelectual
        </h3>
        <p data-id="element-83">
          Todos los textos, ilustraciones, diseños y elementos del libro y de
          este sitio web están protegidos por las leyes de propiedad intelectual
          aplicables. La adquisición del libro no transfiere ningún derecho de
          autor sobre la obra.
        </p>

        <h3 className="font-serif text-amber-400 text-lg mt-4" data-id="element-84">
          8. Limitación de responsabilidad
        </h3>
        <p data-id="element-85">
          En la máxima medida permitida por la ley, no nos hacemos responsables
          de daños indirectos, incidentales o consecuentes derivados del uso o
          interpretación del contenido del libro. Cada lector es responsable de
          cómo integra y aplica las ideas presentadas en su propia vida.
        </p>

        <h3 className="font-serif text-amber-400 text-lg mt-4" data-id="element-86">
          9. Modificaciones
        </h3>
        <p data-id="element-87">
          Nos reservamos el derecho de modificar estos Términos y Condiciones en
          cualquier momento. La versión vigente será siempre la publicada en
          esta página.
        </p>

        <h3 className="font-serif text-amber-400 text-lg mt-4" data-id="element-88">
          10. Ley aplicable
        </h3>
        <p data-id="element-89">
          Estos términos se rigen por la legislación aplicable al territorio
          desde el cual se opera este sitio. Cualquier controversia será
          resuelta conforme a dicha jurisdicción.
        </p>

        <p className="font-serif italic text-amber-200/80 mt-6 text-center" data-id="element-90">
          Este libro es una invitación, no una instrucción. El viaje siempre es
          tuyo.
        </p>
      </Modal>
    </footer>;
};